<div class="myprofile_content_autorollover">
  @if(!toggleEdit){
    <div class="col-md-9 col-sm-7 col-xs-7 myprofile_arrheader">
      {{ cmsContent.title }}
    </div>
    <div class="col-md-3 col-sm-5 col-xs-5 myprofile_enrollheader">
      @if (isPreBookEnabled){
      @if (userARRData?.enrolledStatus != 'Enrolled') {
        <a
          class="anchorunderline"
          [routerLink]="cmsContent.urlLink"
          >{{cmsContent.subcontent}}
          <div class="global_blackarrow"></div
          ></a>
        } @else {
          @if (!toggleEdit) {
            <div (click)="toggleEditAutoRollover()">
              <div class="myprofilarr_editbtn" id="myprofilarr_editbtn">
                {{ "autorollover.editLabel" | cxTranslate
                }}<img src="/assets/images/edit.png" width="20" alt="Edit" />
              </div>
            </div>
          }
        }
      }
      </div>

      <div class="col-lg-12 col-md-12 autorollover_status">
        <div class="col-lg-4 col-md-4 arr_item">
          <div class="statusheader">
            {{ "autorollover.statusLabel" | cxTranslate }}
          </div>
          <div
            class="statustext"
            [ngClass]="{ red: userARRData?.enrolledStatus != 'Enrolled' }"
            >
            {{ userARRData?.enrolledStatus }}
          </div>
        </div>
        @if(userARRData?.enrolledStatus == 'Enrolled'){
          <div class="col-lg-4 col-md-4 arr_item">
            <div class="statusheader">
              {{ "autorollover.dateLabel" | cxTranslate }}
            </div>
            <div class="statustext">{{ userARRData?.enrolledDate }}</div>
          </div>
          <div class="col-lg-4 col-md-4 arr_item">
            <div class="statusheader">
              {{ "autorollover.enrollbyLabel" | cxTranslate }}
            </div>
            <div class="statustext">{{ userARRData?.enrolledBy }}</div>
          </div>
        }
      </div>
    }
    @else{

    <div class="col-md-6 col-sm-10 col-xs-12 myprofile_arrheader">
      {{ cmsContent.title }}
    </div>
    <div class="col-xs-12 col-md-12 col-lg-12 arr_disablemessage">
      {{ cmsContent.content }}
    </div>
    <div class="col-xs-12 col-md-12 col-lg-12 arr_disablebutton">
      <button
        class="global_greybtn cancel_btn"
        (click)="toggleEditAutoRollover()"
        >
        {{ "autorollover.cancelLabel" | cxTranslate }}
      </button>
      <button class="global_greybtn disable_btn" (click)="disableAutoRollover()">
        {{ "autorollover.disableLabel" | cxTranslate }}
      </button>
    </div>
  }
</div>
